/**
 * 报价配置
 */
export const tableConfig = {
  columns: [
    {
      label: "分配状态",
      prop: "allocationStatus",
      width: "100",
      align: "center",
      showSlot: true,
      role: ["admin", "ZB", "zb"], // 权限
    },
    {
      label: "转APP",
      prop: "turnApp",
      width: "80",
      align: "center",
      showSlot: true,
      role: ["admin", "ZB", "zb"],
    },
    {
      label: "保险公司",
      prop: "insurancecompanyname",
      width: "90",
      align: "center",
    },
    {
      label: "询价号",
      prop: "vehiclenumber",
      align: "center",
      showSlot: true,
      minWidth: "250",
    },
    {
      label: "停放地",
      prop: "vehicletemporary",
      width: "120",
      align: "center",
      showOverflowTooltip: true,
    },
    {
      label: "事故类型",
      prop: "vehicledamagecause",
      width: "90",
      align: "center",
    },
    {
      label: "车牌号",
      prop: "licenseplate",
      width: "130",
      align: "center",
      showOverflowTooltip: true,
    },
    {
      label: "车型",
      prop: "vehiclemodel",
      align: "center",
      minWidth: "260",
      showOverflowTooltip: true,
    },
    {
      label: "任务结束时间",
      prop: "auctionendtime",
      width: "180",
      align: "center",
      showSlot: true,
    },
    /**
     * 在总部端显示“会员报价”的“金额”，
     * 这个“金额”显示为app期车价或者内网会员报价中的“最高价
     */
    // adminBidPrice
 /*   {
      label: "会员报价",
      prop: "",
      width: "90",
      align: "center",
      role: ["admin", "ZB", "zb"], // 权限
    },*/
    {
      label: "会员报价",
      prop: "vipBidPrice",
      minWidth: "90",
      align: "center",
      role: ["vip"], // 权限
    },
/*    {
      label: "报价状态",
      prop: "currentBidStatus",
      width: "85",
      align: "center",
      showSlot: true,
      role: ["vip"], // 权限
    },*/
    {
      label: "会员状态",
      prop: "bidStatus",
      width: "85",
      align: "center",
      showSlot: true,
      role: ["admin", "ZB", "zb"], // 权限
    },
    {
      label: "会员名称",
      prop: "userName",
      width: "120",
      align: "center",
      role: ["vip"], // 权限
      showOverflowTooltip: true,
    },
    {
      label: "上报价",
      prop: "selfbidprice",
      width: "110",
      align: "center",
      role: ["admin", "ZB", "zb"], // 权限
      showSlot: true,
    },
    // {
    //   label: '上报状态',
    //   prop: 'reportStatus',
    //   width: '88',
    //   align: 'center',
    //   showSlot: true,
    //   role: ['admin', 'ZB', 'zb'] // 权限
    // },
    {
      label: "改价",
      prop: "gj",
      width: "100",
      align: "center",
      role: ["admin", "ZB", "zb"], // 权限
    },
    // TODO：渠道
    {
      label: "渠道",
      prop: "channel",
      minWidth: "100",
      align: "center",
      role: ["admin", "ZB", "zb"], // 权限
    },

    {
      label: "操作",
      width: "180",
      align: "center",
      showSlot: true,
      action: true,
      fixed: "right",
    },
  ],

  selection: {
    show: true,
    width: "35",
    fixed: true,
    align: "center",
    reserveSelection: true,
  },
  border: true,
};

/**
 * 中标配置
 */
export const bidAllocationConfig = {
  columns: [
    {
      label: "转委托",
      prop: "isEntrust",
      width: "80",
      align: "center",
      showSlot: true,
      role: ["admin", "ZB", "zb"],
    },
    {
      label: "转APP",
      prop: "turnApp",
      width: "80",
      align: "center",
      showSlot: true,
      role: ["admin", "ZB", "zb"],
    },
    {
      label: "保险公司",
      prop: "insurancecompanyname",
      width: "100",
      align: "center",
    },
    {
      label: "询价号",
      prop: "vehiclenumber",
      align: "center",
      showSlot: true,
      minWidth: "250",
    },
    {
      label: "停放地",
      prop: "vehicletemporary",
      width: "100",
      align: "center",
      showOverflowTooltip: true,
    },
    {
      label: "事故类型",
      prop: "vehicledamagecause",
      width: "85",
      align: "center",
    },
    {
      label: "车牌号",
      prop: "licenseplate",
      width: "100",
      align: "center",
    },
    {
      label: "车型",
      prop: "vehiclemodel",
      minWidth: "260",
      align: "center",
      showOverflowTooltip: true,
    },
    // 会员报价 -- vip权限
    {
      label: "会员报价",
      prop: "vipBidPrice",
      minWidth: "100",
      align: "center",
      role: ["vip"],
    },
    {
      label: "是否采用",
      prop: "isUse",
      width: "120",
      align: "center",
      showSlot: true,
      role: ["vip"],
    },
    {
      label: "会员名称",
      prop: "userName",
      width: "120",
      align: "center",
      role: ["vip"],
    },
    {
      label: "上报价",
      prop: "selfbidprice",
      width: "",
      align: "center",
      role: ["admin", "ZB", "zb"],
    },
    {
      label: "大会员",
      prop: "isAdminUse",
      width: "100",
      align: "center",
      showSlot: true,
      role: ["admin", "ZB", "zb"],
    },
    {
      label: "app会员",
      prop: "isAppUse",
      width: "100",
      align: "center",
      showSlot: true,
      role: ["admin", "ZB", "zb"],
    },

  /*  {
      label: "中标会员",
      prop: "userName",
      width: "82",
      align: "center",
      showSlot: true,
      role: ["admin", "ZB", "zb"],
    },

    {
      label: "APP中标",
      prop: "isAppBid",
      width: "82",
      align: "center",
      showSlot: true,
      role: ["admin", "ZB", "zb"],
    },*/


    {
      label: "中标公示时间",
      prop: "auctionendtime",
      width: "180",
      align: "center",
      showSlot: true,
      showOverflowTooltip: true,
    },
    {
      label: "中标价",
      prop: "bidPrice",
      width: "",
      showSlot: true,
      align: "center",
    },
    {
      label: "中标公司",
      prop: "winningCompany",
      minWidth: "180",
      align: "center",
      showSlot: true,
      showOverflowTooltip: true,
    },
    {
      label: "中标状态",
      prop: "ifzhongbiao",
      width: "120",
      align: "center",
      showSlot: true,
    },
/*    {
      label: "下车",
      prop: "isWithdrawn",
      width: "72",
      align: "center",
      showSlot: true,
      role: ["admin", "ZB", "zb"],
    },*/
/*    {
      label: "会员类型",
      prop: "userType",
      width: "82",
      align: "center",
      showSlot: true,
      role: ["admin", "ZB", "zb"],
    },*/



    {
      label: "渠道",
      prop: "channel",
      width: "120",
      align: "center",
      role: ["admin", "ZB", "zb"],
    },

    // {
    //   label: '报价状态',
    //   prop: 'bidStatus',
    //   width: '120',
    //   align: 'center',
    //   showSlot: true
    // },

    // {
    //   label: '上报状态',
    //   prop: 'reportStatus',
    //   width: '120',
    //   align: 'center',
    //   showSlot: true,
    //   role: ['admin', 'ZB', 'zb']
    // },

   // {
    //  label: "本人是否中标",
    //  prop: "isSelfBid",
    //  minWidth: "120",
   //   align: "center",
    //  showSlot: true,
   //   role: ["vip"],
   // },
    {
      label: "操作",
      width: "190",
      align: "center",
      showSlot: true,
      action: true,
      fixed: "right",
    },
  ],

  selection: {
    show: true,
    width: "35",
    fixed: true,
    align: "center",
    reserveSelection: false,
  },
  border: true,
};

/**
 * 保险公司 -- 报价
 */
export const offerConfig = [
  {
    label: "平安报价",
    value: "pingan",
  },
  {
    label: "人保报价",
    value: "renbao",
  },
  {
    label: "太保报价",
    value: "taibao",
  },
  {
    label: "中华报价",
    value: "zhonghua",
  },
  {
    label: "阳光报价",
    value: "yangguang",
  },
  {
    label: "太平报价",
    value: "taiping",
  },
  {
    label: "珠峰报价",
    value: "zhufeng",
  },
  {
    label: "渠道-报价",
    value: "qudao",
  },
  {
    label: "其他报价",
    value: "qita",
  },
  {
    label: "二手车-报价",
    value: "ershou",
  },
];

/**
 * 保险公司 -- 中标
 */
export const insuranceCompany = [
  {
    label: "平安中标",
    value: "pingan",
  },
  {
    label: "人保中标",
    value: "renbao",
  },
  {
    label: "渠道-中标",
    value: "qudao",
  },
  {
    label: "其他中标",
    value: "qita",
  },
  {
    label: "二手车-中标",
    value: "ershou",
  },
];

/**
 * 通过路由找出 offerConfig 对应的value字段
 * @param {*} route
 * @returns
 */
export const findOfferConfig = (route) => {
  let value = "";
  offerConfig.forEach((item) => {
    if (item.label === route) {
      value = item.value;
    }
  });
  return value;
};

// 保险公司
export const insuranceCompanyList = [
  {
    label: "太平",
    value: "taiping",
  },
  {
    label: "大地",
    value: "dadi",
  },
  {
    label: "黄河",
    value: "huanghe",
  },
  {
    label: "珠峰",
    value: "zhufeng",
  },
  {
    label: "永安",
    value: "yongan",
  },
  {
    label: "燕赵",
    value: "yanzhao",
  },
  {
    label: "中煤",
    value: "zhongmei",
  },
  {
    label: "国寿财",
    value: "guoshou",
  },
  {
    label: "人保",
    value: "renbao",
  },
  {
    label: "平安",
    value: "pingan",
  },
  {
    label: "中华",
    value: "zhonghua",
  },
  {
    label: "阳光",
    value: "yangguang",
  },
  {
    label: "大家",
    value: "dajia",
  },
  {
    label: "国任",
    value: "guoren",
  },
  {
    label: "天平",
    value: "tianping",
  },
  {
    label: "华农",
    value: "huanong",
  },
  {
    label: "紫金",
    value: "zijin",
  },
  {
    label: "永城",
    value: "yongcheng",
  },
  {
    label: "富德",
    value: "fude",
  },
  {
    label: "泰山",
    value: "taishan",
  },
  {
    label: "中银",
    value: "zhongyin",
  },
  {
    label: "出口信用",
    value: "chukou",
  },
  {
    label: "中路",
    value: "zhonglu",
  },
  {
    label: "英大",
    value: "yingda",
  },
  {
    label: "太平洋",
    value: "taipingyang",
  },
  {
    label: "锦泰",
    value: "jintai",
  },
  {
    label: "华安",
    value: "huaan",
  },
  {
    label: "华泰",
    value: "huatai",
  },
  {
    label: "渤海",
    value: "bohai",
  },
  {
    label: "都帮",
    value: "dubang",
  },
  {
    label: "众诚",
    value: "zhongcheng",
  },
  {
    label: "安诚",
    value: "ancheng",
  },
  {
    label: "天安",
    value: "tianan",
  },
  {
    label: "亚太",
    value: "yatai",
  },
  {
    label: "泰康",
    value: "taikang",
  },
  {
    label: "鼎和",
    value: "dinghe",
  },
  {
    label: "恒邦",
    value: "hengbang",
  },
  {
    label: "合众",
    value: "hezhong",
  },
  {
    label: "诚泰",
    value: "chengtai",
  },
  {
    label: "森威拍卖",
    value: "yonghe",
  },
];

/**
 * 通过 findOfferConfigLabel 的value 找出对应的 label
 */
export const findOfferConfigLabel = (value) => {
  let label = "";
  insuranceCompanyList.forEach((item) => {
    if (item.value === value) {
      label = item.label;
    }
  });
  return label;
};
